const getDefaultState = () => {
  return {
    customerName: '',
    customerPhoneNumber: '',
    customerEmail: '',
    customerBirth: '',
    customerGender: '',
    customerMemo: '',
    customerZipCode: '',
    customerBaseAddress: '',
    customerDetailAddress: '',
    businessNumberFromServer: '',
    businessNumberFromSocket: '',
    customerCompanyName: '',
    customerCompanyPhoneNumber: '',
    isChangeCustomer: false
  };
};
const state = getDefaultState();

const getters = {
  customer: (state) => {
    return {
      name: state.customerName,
      phoneNumber: state.customerPhoneNumber,
      email: state.customerEmail,
      birth: state.customerBirth,
      gender: state.customerGender,
      memo: state.customerMemo,
      zipCode: state.customerZipCode,
      baseAddress: state.customerBaseAddress,
      detailAddress: state.customerDetailAddress,
      id: state.customerId,
      businessNumber: state.businessNumberFromSocket || state.businessNumberFromServer,
      companyName: state.customerCompanyName,
      companyPhoneNumber: state.customerCompanyPhoneNumber
    };
  },
  customerName: (state) => {
    return state.customerName;
  },
  customerPhoneNumber: (state) => {
    return state.customerPhoneNumber;
  },
  customerEmail: (state) => {
    return state.customerEmail;
  },
  customerBirth: (state) => {
    return state.customerBirth;
  },
  customerGender: (state) => {
    return state.customerGender;
  },
  customerMemo: (state) => {
    return state.customerMemo;
  },
  customerZipCode: (state) => {
    return state.customerZipCode;
  },
  customerBaseAddress: (state) => {
    return state.customerBaseAddress;
  },
  customerDetailAddress: (state) => {
    return state.customerDetailAddress;
  },
  isChangeCustomer: (state) => {
    return state.isChangeCustomer;
  },
  customerId: (state) => {
    return state.customerId;
  },
  businessNumberFromServer: (state) => {
    return state.businessNumberFromServer;
  },
  businessNumberFromSocket: (state) => {
    return state.businessNumberFromSocket;
  },
  customerCompanyName: (state) => {
    return state.customerCompanyName;
  },
  customerCompanyPhoneNumber: (state) => {
    return state.customerCompanyPhoneNumber;
  }
};

const actions = {};

const mutations = {
  resetCustomer(state) {
    Object.assign(state, getDefaultState());
  },
  changeCustomer(state, customer) {
    state.customerName = customer.name;
    state.customerPhoneNumber = customer.phoneNumber;
    state.customerEmail = customer.email;
    state.customerBirth = customer.birth;
    state.customerGender = customer.gender;
    state.customerMemo = customer.memo;
    state.customerId = customer.id;
    state.customerCompanyName = customer.companyName;
    state.customerCompanyPhoneNumber = customer.companyPhoneNumber;
  },
  changeCustomerName(state, name) {
    state.customerName = name;
  },
  changeCustomerPhoneNumber(state, phoneNumber) {
    state.customerPhoneNumber = phoneNumber;
  },
  changeCustomerEmail(state, email) {
    state.customerEmail = email;
  },
  changeCustomerBirth(state, birth) {
    state.customerBirth = birth;
  },
  changeCustomerGender(state, gender) {
    state.customerGender = gender;
  },
  changeCustomerMemo(state, memo) {
    state.customerMemo = memo;
  },
  changeCustomerZipCode(state, zipCode) {
    state.customerZipCode = zipCode;
  },
  changeCustomerBaseAddress(state, baseAddress) {
    state.customerBaseAddress = baseAddress;
  },
  changeCustomerDetailAddress(state, detailAddress) {
    state.customerDetailAddress = detailAddress;
  },
  changeIsCustomer(state, isChangeCustomer) {
    state.isChangeCustomer = isChangeCustomer;
  },
  changeCustomerId(state, id) {
    state.customerId = id;
  },
  changeBusinessNumberFromServer(state, businessNumber) {
    state.businessNumberFromServer = businessNumber;
  },
  changeBusinessNumberFromSocket(state, businessNumber) {
    state.businessNumberFromSocket = businessNumber;
  },
  changeCustomerCompanyName(state, customerCompanyName) {
    state.customerCompanyName = customerCompanyName;
  },
  changeCustomerCompanyPhoneNumber(state, customerCompanyPhoneNumber) {
    state.customerCompanyPhoneNumber = customerCompanyPhoneNumber;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/index.js